import { Quote as Quote_kojaro } from './Quote.kojaro';
import { Quote as Quote_phosphor } from './Quote.phosphor';
import { Quote as Quote_zoomg } from './Quote.zoomg';
import { Quote as Quote_zoomit } from './Quote.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Quote_kojaro;

    case 'zoomg':
      return Quote_zoomg;

    case 'phosphor':
      return Quote_phosphor;

    default:
      return Quote_zoomit;
  }
};

export const Quote = IconRenderer();
